// Hotspot section product page
document.addEventListener("DOMContentLoaded", function () {
  const hotspotSections = document.querySelectorAll("hot-spots");

  hotspotSections.forEach(function (hotspot) {
    const tabs = hotspot.querySelectorAll(".hotspot__button");
    const panels = hotspot.querySelectorAll(".hotspot-content__block");

    if (!tabs.length || !panels.length) return;

    /*
     * Set up the Tabs / Tabpanel relationship
     */
    tabs.forEach(function (tab, index) {
      const target = tab.getAttribute("data-button");

      if (!target) return;

      const panel = hotspot.querySelector(
        '.hotspot-content__block[data-hotspot-block="' + target + '"]',
      );

      if (!panel) return;

      // Unique IDs
      const tabId = "hotspot-tab-" + target;
      const panelId = "hotspot-panel-" + target;

      tab.setAttribute("id", tabId);
      tab.setAttribute("role", "tab");
      tab.setAttribute("aria-controls", panelId);

      panel.setAttribute("id", panelId);
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", tabId);

      /*
       * Set initial state
       */
      const isActive =
        panel.classList.contains("is-active") ||
        tab.classList.contains("is-active");

      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");

      if (isActive) {
        panel.hidden = false;
      } else {
        panel.hidden = true;
      }
    });

    /*
     * Add tablist role to the hotspot buttons container
     */
    const tabList = hotspot.querySelector(".hotspots__buttons");

    if (tabList) {
      tabList.setAttribute("role", "tablist");
      tabList.setAttribute("aria-label", "Product features");
    }

    /*
     * Activate a tab
     */
    function activateTab(tab, moveFocus) {
      const target = tab.getAttribute("data-button");

      if (!target) return;

      const panel = hotspot.querySelector(
        '.hotspot-content__block[data-hotspot-block="' + target + '"]',
      );

      if (!panel) return;

      /*
       * Update all tabs
       */
      tabs.forEach(function (item) {
        const selected = item === tab;

        item.setAttribute("aria-selected", selected ? "true" : "false");

        item.setAttribute("tabindex", selected ? "0" : "-1");

        item.classList.toggle("is-active", selected);
      });

      /*
       * Update all panels
       */
      panels.forEach(function (item) {
        const selected = item === panel;

        item.classList.toggle("is-active", selected);
        item.hidden = !selected;
      });

      if (moveFocus) {
        tab.focus();
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activateTab(tab, false);
      });
    });

    tabs.forEach(function (tab, index) {
      tab.addEventListener("keydown", function (event) {
        let newIndex = null;

        switch (event.key) {
          case "ArrowRight":
          case "ArrowDown":
            event.preventDefault();

            newIndex = (index + 1) % tabs.length;
            break;

          case "ArrowLeft":
          case "ArrowUp":
            event.preventDefault();

            newIndex = (index - 1 + tabs.length) % tabs.length;
            break;

          case "Home":
            event.preventDefault();

            newIndex = 0;
            break;

          case "End":
            event.preventDefault();

            newIndex = tabs.length - 1;
            break;

          case "Enter":
          case " ":
            event.preventDefault();

            activateTab(tab, true);
            return;

          default:
            return;
        }

        if (newIndex !== null) {
          activateTab(tabs[newIndex], true);
        }
      });
    });

    const selectedTab = Array.from(tabs).find(function (tab) {
      return tab.getAttribute("aria-selected") === "true";
    });

    if (selectedTab) {
      activateTab(selectedTab, false);
    } else {
      activateTab(tabs[0], false);
    }
  });
});

// Carousel prev/next arrows + pause on keyboard focus (Sept 2026 v15)
// Covers the announcement bar (#AnnouncementSlider) and hero slideshows
// (#Slideshow-<section id>). theme.js destroys and re-creates the
// announcement slider whenever the viewport crosses 769px, and hero
// slideshows below the first section only initialise once scrolled into
// view, so the Flickity instance is looked up when the user acts instead of
// being captured once on DOMContentLoaded (that closure went dead).
(function () {
  var ARROWS = '.announcement-slider__prev, .announcement-slider__next, .hero-slider__prev, .hero-slider__next';
  var PREV_ARROWS = '.announcement-slider__prev, .hero-slider__prev';

  function getFlickity(root) {
    if (!root || typeof Flickity === 'undefined') return null;
    var flkty = Flickity.data(root);
    return flkty && flkty.isActive ? flkty : null;
  }

  // The slider an arrow drives: its aria-controls target, else the carousel
  // it sits in.
  function rootForArrow(btn) {
    var id = btn.getAttribute('aria-controls');
    var root = id ? document.getElementById(id) : null;
    if (root) return root;
    if (btn.closest('.announcement-bar')) return document.getElementById('AnnouncementSlider');
    var section = btn.closest('[data-section-id]');
    return section ? document.getElementById('Slideshow-' + section.getAttribute('data-section-id')) : null;
  }

  // The slider that owns a focused element, or null.
  function rootForFocus(el) {
    if (el.closest('.announcement-bar')) return document.getElementById('AnnouncementSlider');
    var section = el.closest('[data-section-type="slideshow-section"]');
    return section ? document.getElementById('Slideshow-' + section.getAttribute('data-section-id')) : null;
  }

  // Stop autoplay the way the theme's own pause button does (theme.js
  // _togglePause) and add is-paused to that button so its label flips to
  // Play and its next click resumes rotation.
  function pauseRotation(flkty, root) {
    if (!flkty.options.autoPlay) return;
    flkty.stopPlayer();
    var wrapper = root.closest('.slideshow-wrapper');
    var pauseBtn = wrapper ? wrapper.querySelector('.slideshow__pause') : null;
    if (pauseBtn) pauseBtn.classList.add('is-paused');
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest(ARROWS) : null;
    if (!btn) return;
    var root = rootForArrow(btn);
    var flkty = getFlickity(root);
    if (!flkty) return;
    pauseRotation(flkty, root);
    if (btn.matches(PREV_ARROWS)) {
      flkty.previous();
    } else {
      flkty.next();
    }
  });

  // WAI-ARIA APG carousel: rotation stops when keyboard focus enters the
  // carousel and stays stopped until the user presses Play. Otherwise the
  // next auto-advance makes the focused announcement link / slide CTA
  // aria-hidden + inert and focus drops to <body> or is stranded on a hidden
  // link. The pause button and arrows are excluded: a mouse or screen-reader
  // activation of Pause fires focusin before click, and pausing here would
  // let the click's _togglePause resume rotation straight away.
  document.addEventListener('focusin', function (evt) {
    var target = evt.target;
    if (!target || !target.closest) return;
    if (target.closest('.slideshow__pause, ' + ARROWS)) return;
    var root = rootForFocus(target);
    var flkty = getFlickity(root);
    if (flkty && flkty.player && flkty.player.state === 'playing') {
      pauseRotation(flkty, root);
    }
  });

  // Announcement arrows are hidden by accessibility.css unless the bar has
  // this class, i.e. only while a live slider exists (not without JS, not
  // for a single announcement, not on desktop with compact off).
  function syncAnnouncementArrows() {
    var slider = document.getElementById('AnnouncementSlider');
    var bar = slider ? slider.closest('.announcement-bar') : null;
    if (!bar) return;
    bar.classList.toggle('announcement-bar--slider', !!getFlickity(slider));
  }

  // theme.js rebuilds (or drops) the slider on these events. Deferred so the
  // check runs after its handlers whatever order they were registered in.
  function syncAnnouncementArrowsLater() {
    setTimeout(syncAnnouncementArrows, 0);
  }

  syncAnnouncementArrows();
  document.addEventListener('DOMContentLoaded', syncAnnouncementArrows);
  document.addEventListener('matchSmall', syncAnnouncementArrowsLater);
  document.addEventListener('unmatchSmall', syncAnnouncementArrowsLater);
  document.addEventListener('shopify:section:load', syncAnnouncementArrowsLater);
})();

// Hero slideshow pagination dots
// Flickity renders them as empty <li>s in an unlabelled <ol>, read as an empty
// group. Expose them as a labelled group of named, keyboard-operable buttons.
// Dots are (re)built when Flickity initialises, so watch each slideshow.
(function () {
  var ROOTS = '[data-section-type="slideshow-section"] [id^="Slideshow-"]';

  function enhanceDots(root) {
    var holder = root.querySelector(':scope > .flickity-page-dots');
    if (!holder) return;
    var dots = holder.querySelectorAll('.dot');
    holder.setAttribute('role', 'group');
    holder.setAttribute('aria-label', 'Choose slide to display');
    dots.forEach(function (dot, i) {
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + dots.length);
      if (dot.getAttribute('aria-current') === 'step') dot.setAttribute('aria-current', 'true');
    });
  }

  function watch(root) {
    if (root._a11yDotsObserver) return;
    enhanceDots(root);
    root._a11yDotsObserver = new MutationObserver(function () {
      enhanceDots(root);
    });
    root._a11yDotsObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current']
    });
  }

  function init() {
    document.querySelectorAll(ROOTS).forEach(watch);
  }

  document.addEventListener('keydown', function (evt) {
    var dot = evt.target;
    if (!dot.matches || !dot.matches('.flickity-page-dots .dot[role="button"]')) return;
    if (evt.key !== 'Enter' && evt.key !== ' ') return;
    evt.preventDefault();
    dot.click();
  });

  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

// Product thumbnails: announce "Product image N of M" in the gallery live region
document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
  thumb.addEventListener('click', function () {
    var announcement = document.getElementById('gallery-warning-announcement');

    if (announcement) {
      var currentImage = Number(this.dataset.index) + 1;
      var totalImages = this.dataset.total;

      // Clear previous message
      announcement.textContent = '';

      // Add announcement
      setTimeout(function () {
        announcement.textContent =
          "Product image " + currentImage + " of " + totalImages + " visible in gallery viewer.";

        // Remove announcement after 2 seconds
        setTimeout(function () {
          announcement.textContent = '';
        }, 2000);

      }, 100);
    }
  });
});

// Size guide popup (<tool-tip>) focus handling (Sept 2026 v15)
// theme.js ToolTip._open runs trapFocus (which focuses the container) while
// the popup is still display:none, so focus never moved in, and _close()
// never returned it. This watches data-tool-tip-open, which ToolTip sets to
// 'true' / 'false', so every close path (close button, Escape, overlay
// click) is covered and nothing lingers between openings.
(function () {
  function focusWhenShown(tip, tries) {
    if (tip.getAttribute('data-tool-tip-open') !== 'true') return;
    if (tip.getClientRects().length) {
      if (!tip.hasAttribute('tabindex')) tip.setAttribute('tabindex', '-1');
      tip.focus();
    } else if (tries < 10) {
      requestAnimationFrame(function () {
        focusWhenShown(tip, tries + 1);
      });
    }
  }

  function watch(tip) {
    var trigger = null;
    var eventTrigger = null;

    // Fallback for browsers that do not focus a clicked button (Safari): the
    // trigger button inside the <tool-tip-trigger> that dispatched the event.
    document.addEventListener('tooltip:open', function (evt) {
      var host = evt.target;
      eventTrigger = host && host.querySelector ? (host.querySelector('.tool-tip-trigger__btn') || host) : null;
    });

    new MutationObserver(function () {
      if (tip.getAttribute('data-tool-tip-open') === 'true') {
        var active = document.activeElement;
        trigger = active && active !== document.body && !tip.contains(active) ? active : eventTrigger;
        focusWhenShown(tip, 0);
      } else {
        var current = document.activeElement;
        if (trigger && trigger.isConnected && (!current || current === document.body || tip.contains(current))) {
          trigger.focus();
        }
        trigger = null;
        eventTrigger = null;
      }
    }).observe(tip, { attributes: true, attributeFilter: ['data-tool-tip-open'] });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('tool-tip'), watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// PowerMapper level A / AA fixes for third-party and merchant content (Oct 2026)
// None of these change what sighted users see. Judge.me, POWR and the
// product descriptions render or re-render after load, so the fixes re-run
// (debounced) whenever the DOM changes.
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  // WCAG 4.1.2 / ARIA 5.2.9: role="img" makes its children presentational,
  // but Judge.me puts a focusable "5.00 out of 5" link inside
  // .jdgm-rev-widg__summary-stars. Drop the role, keep its label as
  // sr-only text, and hide the CSS-drawn star glyphs so the link is voiced.
  function fixRoleImgWithFocusable(root) {
    root.querySelectorAll('[role="img"]').forEach(function (el) {
      if (el.tagName === 'svg' || el.tagName === 'IMG') return;
      if (!el.querySelector(FOCUSABLE)) return;
      var label = el.getAttribute('aria-label');
      el.removeAttribute('role');
      el.removeAttribute('aria-label');
      if (label && !el.querySelector(':scope > .a11y-role-img-label')) {
        var sr = document.createElement('span');
        sr.className = 'visually-hidden a11y-role-img-label';
        sr.textContent = label;
        el.insertBefore(sr, el.firstChild);
      }
      Array.prototype.forEach.call(el.children, function (child) {
        if (child.classList.contains('a11y-role-img-label')) return;
        if (!child.textContent.trim() && !child.querySelector(FOCUSABLE + ', img, svg')) {
          child.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  // WCAG 1.1.1: POWR's form builder shows an unlabelled spinner GIF while it
  // loads. It is decorative.
  function fixPreloaderImages(root) {
    root.querySelectorAll('img#app-preloader:not([alt]), img[src*="powr-loader"]:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  // WCAG 2.4.4 / 4.1.2: some product descriptions contain an empty duplicate
  // <a href="...#captoe"></a> next to the real "Cap Toe" link. With no
  // content it renders nothing, so remove it rather than leave a nameless
  // link in the tab order. Limited to rich-text content.
  function removeEmptyLinks(root) {
    root.querySelectorAll('.rte a[href]').forEach(function (a) {
      if (a.children.length || a.textContent.trim()) return;
      if (a.hasAttribute('aria-label') || a.hasAttribute('aria-labelledby') || a.hasAttribute('title')) return;
      a.parentNode.removeChild(a);
    });
  }

  // WCAG 3.1.2: Judge.me reviews are shown in whatever language the buyer
  // wrote them in (e.g. French), inside an lang="en" page. Tag a review
  // with its language only when common function words make it unambiguous.
  var LANG_WORDS = {
    fr: ['le', 'la', 'les', 'des', 'est', 'une', 'et', 'pour', 'avec', 'pas', 'mais', 'que', 'très', 'du', 'je', 'sont', 'dans', 'sur', 'bonne', 'trop'],
    de: ['der', 'die', 'das', 'und', 'ist', 'nicht', 'ein', 'eine', 'sehr', 'mit', 'für', 'auch', 'ich', 'sind', 'auf', 'gut', 'schuhe'],
    es: ['el', 'los', 'las', 'es', 'muy', 'una', 'con', 'para', 'pero', 'que', 'por', 'del', 'buena', 'son', 'zapatos'],
    en: ['the', 'and', 'is', 'are', 'very', 'with', 'for', 'but', 'this', 'that', 'was', 'they', 'great', 'boots', 'fit', 'of', 'to', 'it', 'my', 'i']
  };

  function detectLang(text) {
    var words = text.toLowerCase().match(/[a-zà-öø-ÿß]+/g) || [];
    if (words.length < 4) return null;
    var scores = {};
    Object.keys(LANG_WORDS).forEach(function (lang) {
      scores[lang] = words.filter(function (w) { return LANG_WORDS[lang].indexOf(w) !== -1; }).length;
    });
    var best = 'en';
    Object.keys(scores).forEach(function (lang) {
      if (scores[lang] > scores[best]) best = lang;
    });
    if (best === 'en' || scores[best] < 3 || scores[best] < scores.en * 2) return null;
    return best;
  }

  function tagReviewLanguage(root) {
    var pageLang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    root.querySelectorAll('.jdgm-rev__content:not([data-a11y-lang-checked])').forEach(function (el) {
      el.setAttribute('data-a11y-lang-checked', '');
      if (el.hasAttribute('lang')) return;
      var lang = detectLang(el.textContent);
      if (lang && lang !== pageLang) el.setAttribute('lang', lang);
    });
  }

  function run() {
    var root = document.body;
    if (!root) return;
    fixRoleImgWithFocusable(root);
    fixPreloaderImages(root);
    removeEmptyLinks(root);
    tagReviewLanguage(root);
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      run();
    }, 150);
  }

  function init() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Contact form submission status (Oct 2026)
// After a contact form posts, the page reloads. If the page shows its own
// message marked [data-a11y-form-status] (the report-a-web-issue form),
// move focus to it so it is read and keyboard users start from there.
// Otherwise write the message from snippets/formsubmissionmessage.liquid
// into the #A11yFormStatus live region; it is filled after a delay because
// text already present when a live region loads is not announced.
(function () {
  function init() {
    var message = document.querySelector('[data-a11y-form-status]');
    if (message) {
      if (!message.hasAttribute('tabindex')) message.setAttribute('tabindex', '-1');
      // Delay so the browser's jump to the #contactForm hash has finished.
      setTimeout(function () {
        message.focus();
      }, 100);
      return;
    }

    var region = document.getElementById('A11yFormStatus');
    var text = region ? region.getAttribute('data-message') : '';
    if (!text) return;
    setTimeout(function () {
      region.textContent = text;
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Accessible form validation (Oct 2026)
// For forms marked [data-a11y-validate] (report-a-web-issue). Replaces the
// browser's tooltip bubbles, which disappear, can't be zoomed and some
// screen readers miss, with a persistent message under each field:
// - on submit, every required / email field is checked; each error is
//   written into the field's "<id>-error" element, the field gets
//   aria-invalid and is described by the error, and focus moves to the
//   first invalid field (WCAG 3.3.1, 3.3.3, 4.1.2);
// - once a field has shown an error it is re-checked as the user types, so
//   the message clears as soon as it is fixed;
// - a valid form is sent once: the submit button is marked aria-disabled
//   and shows the sending label (it stays focusable, unlike `disabled`).
// Without JS the form keeps the browser's own `required` validation.
(function () {
  var FIELDS = 'input[required], textarea[required], select[required], input[type="email"]';

  // Wording comes from the section settings via data attributes, so it can
  // be edited or translated per store; the English text is a fallback.
  function messageFor(field) {
    var v = field.validity;
    if (!v || v.valid) return '';
    if (v.valueMissing || (field.required && !field.value.trim())) {
      return field.getAttribute('data-a11y-msg-required') || 'Please fill in this field.';
    }
    if (v.typeMismatch && field.type === 'email') {
      return field.getAttribute('data-a11y-msg-invalid') || 'Enter a valid email address, for example name@example.com.';
    }
    return field.getAttribute('data-a11y-msg-invalid') || field.validationMessage || 'Please check this field.';
  }

  function setDescribedBy(field, id, add) {
    var ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    var at = ids.indexOf(id);
    if (add && at === -1) ids.push(id);
    if (!add && at !== -1) ids.splice(at, 1);
    if (ids.length) {
      field.setAttribute('aria-describedby', ids.join(' '));
    } else {
      field.removeAttribute('aria-describedby');
    }
  }

  function showError(field, message) {
    var errorId = field.id + '-error';
    var error = document.getElementById(errorId);
    if (message) {
      field.setAttribute('aria-invalid', 'true');
      if (error) {
        error.innerHTML = '';
        var prefix = document.createElement('span');
        prefix.className = 'a11y-sr-only';
        prefix.textContent = 'Error: ';
        error.appendChild(prefix);
        error.appendChild(document.createTextNode(message));
        error.hidden = false;
        setDescribedBy(field, errorId, true);
      }
    } else {
      field.removeAttribute('aria-invalid');
      if (error) {
        error.hidden = true;
        error.textContent = '';
        setDescribedBy(field, errorId, false);
      }
    }
  }

  // Trim before checking so a message of only spaces counts as empty.
  function check(field) {
    if (field.required && field.value && !field.value.trim()) field.value = '';
    var message = messageFor(field);
    showError(field, message);
    return !message;
  }

  function setup(form) {
    if (form.hasAttribute('data-a11y-validate-ready')) return;
    form.setAttribute('data-a11y-validate-ready', '');
    form.setAttribute('novalidate', '');

    var fields = Array.prototype.slice.call(form.querySelectorAll(FIELDS));
    var submit = form.querySelector('[data-a11y-submit]');
    var submitLabel = submit ? submit.textContent.trim() : '';

    fields.forEach(function (field) {
      field.addEventListener('input', function () {
        if (field.getAttribute('aria-invalid') === 'true') check(field);
      });
      field.addEventListener('blur', function () {
        if (field.getAttribute('aria-invalid') === 'true') check(field);
      });
    });

    form.addEventListener('submit', function (evt) {
      if (form.hasAttribute('data-a11y-sending')) {
        evt.preventDefault();
        return;
      }

      var firstInvalid = null;
      fields.forEach(function (field) {
        if (!check(field) && !firstInvalid) firstInvalid = field;
      });

      if (firstInvalid) {
        evt.preventDefault();
        firstInvalid.focus();
        return;
      }

      form.setAttribute('data-a11y-sending', '');
      if (submit) {
        submit.setAttribute('aria-disabled', 'true');
        submit.textContent = form.getAttribute('data-a11y-sending-label') || 'Sending...';
      }
    });

    // Coming back with the browser's Back button can restore the page from
    // the back/forward cache in the "sending" state.
    window.addEventListener('pageshow', function (evt) {
      if (!evt.persisted) return;
      form.removeAttribute('data-a11y-sending');
      if (submit) {
        submit.removeAttribute('aria-disabled');
        submit.textContent = submitLabel;
      }
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('form[data-a11y-validate]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Navigation (#NavDrawer) and collection filter (#FilterDrawer) drawers as
// modal dialogs (Oct 2026)
// theme.js treats the open buttons as disclosures, so screen readers said
// "Site navigation, button, collapsed" for a button that opens a dialog, and
// only Tab was kept inside the open drawer; swipe / reading keys still went
// to the page behind it. This, without touching theme.js:
// - drops aria-expanded from the open button(s). The markup gives them
//   aria-haspopup="dialog", so they read "Menu, button, opens dialog"
//   (APG dialog pattern);
// - makes everything outside the drawer inert while it is open, so screen
//   readers, Tab and clicks can't reach the page behind (WCAG 2.4.3, 1.3.2);
// - returns focus to the open button on close. theme.js only did that when
//   the button still had aria-expanded, which it no longer has.
// Toggles inside the drawers keep aria-expanded: those really are
// disclosures ("Boots submenu, button, collapsed").
// The filter drawer and its button are re-rendered by theme.js after every
// AJAX filter change, so the drawer is looked up again on each open.
(function () {
  var OPEN_CLASS = 'drawer--is-open';
  var CLOSE_DELAY = 550; // theme.js slide-out is 500ms

  function modalDrawer(id, triggers) {
    var drawer = null;
    var drawerObserver = null;
    var lastTrigger = null;
    var madeInert = [];

    function stripExpanded(btn) {
      if (btn.hasAttribute('aria-expanded')) btn.removeAttribute('aria-expanded');
    }

    function setupTrigger(btn) {
      if (btn.hasAttribute('data-a11y-dialog-trigger')) return;
      btn.setAttribute('data-a11y-dialog-trigger', '');
      if (!btn.hasAttribute('aria-haspopup')) btn.setAttribute('aria-haspopup', 'dialog');
      stripExpanded(btn);
      // theme.js sets aria-expanded on init, open and close; take it off again.
      new MutationObserver(function () {
        stripExpanded(btn);
      }).observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
    }

    // Everything except the drawer and its ancestors: the siblings of each
    // element on the path from the drawer up to <body>.
    function setBackgroundInert(on) {
      if (on) {
        madeInert = [];
        var node = drawer;
        while (node && node.parentElement && node !== document.body) {
          Array.prototype.forEach.call(node.parentElement.children, function (sib) {
            if (sib === node || sib.inert || sib.hasAttribute('inert')) return;
            if (/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sib.tagName)) return;
            sib.setAttribute('inert', '');
            madeInert.push(sib);
          });
          node = node.parentElement;
        }
      } else {
        madeInert.forEach(function (el) {
          el.removeAttribute('inert');
        });
        madeInert = [];
      }
    }

    function onOpen() {
      setBackgroundInert(true);
    }

    function onClose() {
      setBackgroundInert(false);
      var trigger = lastTrigger;
      var closed = drawer;
      setTimeout(function () {
        var current = document.getElementById(id);
        if (current && current.classList.contains(OPEN_CLASS)) return;
        var active = document.activeElement;
        var lost = !active || active === document.body || active === document.documentElement || closed.contains(active);
        if (!lost) return;
        // The button that opened it, else the first visible open button.
        if (!trigger || !trigger.isConnected || !trigger.getClientRects().length) {
          trigger = Array.prototype.find.call(document.querySelectorAll(triggers), function (b) {
            return b.getClientRects().length;
          });
        }
        if (trigger) trigger.focus();
      }, CLOSE_DELAY);
    }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll(triggers), setupTrigger);

      var current = document.getElementById(id);
      if (!current || current === drawer) return;
      if (drawerObserver) drawerObserver.disconnect();
      if (madeInert.length) setBackgroundInert(false);
      drawer = current;

      var wasOpen = drawer.classList.contains(OPEN_CLASS);
      if (wasOpen) onOpen();
      drawerObserver = new MutationObserver(function () {
        var isOpen = drawer.classList.contains(OPEN_CLASS);
        if (isOpen === wasOpen) return;
        wasOpen = isOpen;
        if (isOpen) {
          onOpen();
        } else {
          onClose();
        }
      });
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    // Remember which open button was used (capture: runs before theme.js
    // stops the click's propagation), and pick up a re-rendered button/drawer.
    document.addEventListener('click', function (evt) {
      var btn = evt.target && evt.target.closest ? evt.target.closest(triggers) : null;
      if (!btn) return;
      lastTrigger = btn;
      init();
    }, true);
    document.addEventListener('drawerOpen.' + id, init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // theme.js adds its own aria-expanded on DOMContentLoaded; run again after
    // it, and when a section is re-rendered in the theme editor.
    window.addEventListener('load', init);
    document.addEventListener('shopify:section:load', function () {
      setTimeout(init, 0);
    });
  }

  modalDrawer('NavDrawer', '.js-drawer-open-nav');
  modalDrawer('FilterDrawer', '.js-drawer-open-collection-filters');
})();

// Email / phone links: accessible name (Oct 2026)
// mailto: links get aria-label="Email Address: <text>" and tel: links get
// aria-label="Phone number: <text>", where <text> is the link's trimmed
// visible text (or the address / number from the href when the link is
// empty or icon-only). Content added later (AJAX sections, quick view) is
// picked up too.
(function () {
  var TYPES = [
    { selector: 'a[href^="mailto:" i]', scheme: /^mailto:/i, prefix: 'Email Address: ' },
    { selector: 'a[href^="tel:" i]', scheme: /^tel:/i, prefix: 'Phone number: ' }
  ];

  function valueFrom(href, scheme) {
    var value = href.replace(scheme, '').split('?')[0];
    try {
      value = decodeURIComponent(value);
    } catch (e) {}
    return value.split(',')[0].trim();
  }

  function label(link, type) {
    if (link.hasAttribute('data-a11y-contact')) return;
    var text = (link.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) text = valueFrom(link.getAttribute('href') || '', type.scheme);
    if (!text) return;
    link.setAttribute('aria-label', type.prefix + text);
    link.setAttribute('data-a11y-contact', '');
  }

  function scan(root) {
    TYPES.forEach(function (type) {
      if (root.matches && root.matches(type.selector)) label(root, type);
      if (root.querySelectorAll) {
        Array.prototype.forEach.call(root.querySelectorAll(type.selector), function (link) {
          label(link, type);
        });
      }
    });
  }

  function init() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Generic link text: "here", "learn more", "read more"... (Oct 2026)
// Merchant rich text repeats these, so a screen reader's links list showed
// several identical, meaningless "here" links (WCAG 2.4.4). Name each one
// after its destination, taken from the URL slug: "here, Sizing guide".
// The visible words stay first in the name (WCAG 2.5.3); nothing visible
// changes. Links that already have aria-label / aria-labelledby are left as is.
(function () {
  var GENERIC = [
    'here', 'click here', 'click', 'this', 'this link', 'link', 'go',
    'learn more', 'read more', 'more', 'more info', 'more information',
    'see more', 'view more', 'details', 'more details', 'continue',
    'continue reading', 'find out more', 'info'
  ];
  var SECTIONS = ['pages', 'products', 'collections', 'blogs', 'policies', 'account', 'search'];

  function humanize(slug) {
    var text = slug.replace(/\.[a-z0-9]+$/i, '').replace(/[-_+]+/g, ' ').replace(/\s+/g, ' ').trim();
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
  }

  function decode(part) {
    try {
      return decodeURIComponent(part);
    } catch (e) {
      return part;
    }
  }

  function destination(link) {
    var url;
    try {
      url = new URL(link.getAttribute('href'), window.location.href);
    } catch (e) {
      return '';
    }
    if (!/^https?:$/.test(url.protocol)) return '';

    var sameSite = url.host === window.location.host;
    // In-page anchor: use the target's id.
    if (sameSite && url.pathname === window.location.pathname && url.hash) {
      return humanize(decode(url.hash.slice(1)));
    }

    // Skip numeric ids and locale prefixes (/fr, /en-ca).
    var parts = url.pathname.split('/').filter(Boolean).map(decode).filter(function (p) {
      return !/^\d+$/.test(p) && !/^[a-z]{2}(-[a-z]{2})?$/i.test(p);
    });
    var slug = '';
    for (var i = parts.length - 1; i >= 0; i--) {
      if (SECTIONS.indexOf(parts[i]) === -1 || i === 0) {
        slug = parts[i];
        break;
      }
    }
    var name = humanize(slug);
    if (!name) name = sameSite ? 'Home page' : '';
    if (!sameSite) {
      var host = url.hostname.replace(/^www\./, '');
      name = name ? name + ' on ' + host : host;
    }
    return name;
  }

  function label(link) {
    if (link.hasAttribute('data-a11y-generic')) return;
    if (link.hasAttribute('aria-label') || link.hasAttribute('aria-labelledby')) return;
    var text = (link.textContent || '').replace(/\s+/g, ' ').trim();
    var key = text.toLowerCase().replace(/[.,:;!?…»›→>]+$/g, '').trim();
    if (GENERIC.indexOf(key) === -1) return;
    var dest = destination(link);
    if (!dest || dest.toLowerCase() === key) return;
    link.setAttribute('aria-label', text.replace(/[.,:;!?…]+$/, '') + ', ' + dest);
    link.setAttribute('data-a11y-generic', '');
  }

  function scan(root) {
    if (root.matches && root.matches('a[href]')) label(root);
    if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll('a[href]'), label);
  }

  function init() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// External links: "Redirecting to a third-party website, opens in a new tab" (Oct 2026)
// Links to another domain open in a new tab (target="_blank", rel="noopener")
// and announce it. The notice is appended after the link's own name: added
// to aria-label when the link has one, otherwise as screen-reader-only text,
// so nothing visible changes. Runs after the generic-link fix above so its
// aria-labels get the notice too.
(function () {
  var NOTICE = 'Redirecting to a third-party website, opens in a new tab';
  var NOTICE_ID = 'a11y-external-notice';

  function isExternal(link) {
    var url;
    try {
      url = new URL(link.getAttribute('href'), window.location.href);
    } catch (e) {
      return false;
    }
    if (!/^https?:$/.test(url.protocol)) return false;
    var host = url.hostname.replace(/^www\./, '');
    if (host === window.location.hostname.replace(/^www\./, '')) return false;
    if (window.Shopify && window.Shopify.shop && host === window.Shopify.shop) return false;
    return true;
  }

  function noticeEl() {
    var el = document.getElementById(NOTICE_ID);
    if (!el) {
      el = document.createElement('span');
      el.id = NOTICE_ID;
      el.className = 'a11y-sr-only';
      el.textContent = NOTICE;
      document.body.appendChild(el);
    }
    return el;
  }

  function label(link) {
    if (link.hasAttribute('data-a11y-external')) return;
    if (!isExternal(link)) return;
    link.setAttribute('target', '_blank');
    var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') === -1) rel.push('noopener');
    link.setAttribute('rel', rel.join(' '));

    var ariaLabel = (link.getAttribute('aria-label') || '').trim();
    if (ariaLabel) {
      if (ariaLabel.indexOf(NOTICE) === -1) {
        link.setAttribute('aria-label', ariaLabel.replace(/[.,;:]+$/, '') + ', ' + NOTICE);
      }
    } else if (link.hasAttribute('aria-labelledby')) {
      var ids = link.getAttribute('aria-labelledby').split(/\s+/);
      if (ids.indexOf(NOTICE_ID) === -1) {
        noticeEl();
        link.setAttribute('aria-labelledby', ids.concat(NOTICE_ID).join(' '));
      }
    } else if (!link.querySelector(':scope > .a11y-external-text')) {
      var sr = document.createElement('span');
      sr.className = 'a11y-sr-only a11y-external-text';
      sr.textContent = ', ' + NOTICE;
      link.appendChild(sr);
    }
    link.setAttribute('data-a11y-external', '');
  }

  function scan(root) {
    if (root.matches && root.matches('a[href]')) label(root);
    if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll('a[href]'), label);
  }

  function init() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
